<template>
  <div :class="$style.dataTable">
    <div :class="$style.tableHeader">
      <div :class="$style.tableTitle">
        <h6 :class="$style.tableTitleHeader">{{ tableTitle }}</h6>
        <p :class="$style.tableDescriptionText">{{ tableDescription }}</p>
      </div>
      <div v-if="itemsNotEmpty"
           :class="$style.tableButton">
        <app-button v-if="!productsTable"
                    :text="addButton"
                    button-style="accent"
                    :disabled="readOnly"
                    @click.prevent="addNew($event)"
                    :class="$style.addBtn"/>
      </div>
    </div>

    <vue-custom-scrollbar class="scroll-area"
                          :settings="settings">
      <v-simple-table v-if="itemsNotEmpty">
        <template v-slot:default>
          <thead>
          <tr>
            <th v-for="(header, index) in headers"
                :key="index"
                :class="$style.tableHeaderTitle">
              {{ header }}
            </th>
            <th v-if="!ordersTable"></th>
            <th v-if="!ordersTable"></th>
          </tr>
          </thead>
          <tbody>
            <slot name="tableRows" />
          </tbody>
        </template>
      </v-simple-table>

      <div v-else :class="$style.emptyTable">
        <p>{{ emptyText }}</p>
        <div :class="$style.tableButton">
          <app-button v-if="!productsTable"
                      :text="addButton"
                      button-style="accent"
                      :disabled="readOnly"
                      @click.prevent="addNew($event)"
                      :class="$style.addBtn"/>
        </div>
      </div>
    </vue-custom-scrollbar>

  </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  props: {
    tableTitle: {
      type: String,
      default: '',
    },
    tableDescription: {
      type: String,
      default: '',
    },
    addButton: {
      type: String,
      default: 'Add New',
    },
    emptyText: {
      type: String,
      default: 'There is currently nothing added yet. Please click on the button to add new data.',
    },
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    productsTable: {
      type: Boolean,
      default: false,
    },
    ordersTable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        wheelSpeed: 0.3,
      },
    };
  },
  methods: {
    addNew(e) {
      this.$emit('addNew', e);
    },
  },
  computed: {
    itemsNotEmpty() {
      return this.items.length > 0;
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.addBtn {
  padding: 8px 14px;
  font-size: 1.4rem;
  line-height: 1.6rem;
  font-style: normal;
  white-space: nowrap;
}

.emptyTable {
  background-color: $white-color;
  text-align: center;
  padding: 18px 150px;
}

.tableHeader {
  background-color: $left-sidebar-color;
  padding: 13px 10px 13px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tableTitleHeader {
    color: $white-color;
    font-style: normal;
  }

  .tableDescriptionText {
    color: $white-color;
    margin: 0;
    font-size: 1.4rem;
  }
}

.dataTable {
  box-shadow: $forms-shadow;

  th {
    /* Overriding Vuetify style */
    height: auto !important;
  }

  .tableHeaderTitle {
    font-family: $title-font;
    /* Overriding Vuetify style */
    color: $main-text-color !important;
    /* Overriding Vuetify style */
    font-size: 1.6rem !important;
    font-weight: 700;
    line-height: 2.1rem;
    font-style: italic;
    /* Overriding Vuetify style */
    padding: 10px 16px !important;
  }
}
</style>
